import { useEffect, useState } from 'react';

const BARKY_URL =
  'https://storage.readdy-site.link/project_files/c43d99a8-1e00-428b-96a3-32143e86ff11/d6c2f9b6-4541-4f92-a27c-4e3d3602e9a5_barky_sem_fundo.png?v=6c769196e5f19b9901d880a680aabc0f';

const AVATARS = [
  'https://public.readdy.ai/ai/img_res/f64a47894d452e20dc5032f0c0629443.jpg',
  'https://readdy.ai/api/search-image?query=professional%20Latina%20female%20contractor%20headshot%20warm%20smile%20teal%20uniform%20close%20up%20portrait%20clean%20background&width=80&height=80&seq=av2h&orientation=squarish',
  'https://readdy.ai/api/search-image?query=professional%20male%20contractor%20headshot%20confident%20smile%20dark%20teal%20polo%20close%20up%20portrait%20clean%20background&width=80&height=80&seq=av3h&orientation=squarish',
  'https://readdy.ai/api/search-image?query=professional%20female%20contractor%20headshot%20professional%20smile%20branded%20uniform%20close%20up%20portrait%20clean%20background&width=80&height=80&seq=av4h&orientation=squarish',
];

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 150);
    return () => clearTimeout(timer);
  }, []);

  const scrollTo = (id: string) => {
    document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full flex items-stretch overflow-hidden"
      style={{ background: '#FFFFFF', paddingTop: '72px', minHeight: '100vh' }}
    >
      {/* ── LEFT COLUMN ── */}
      <div
        className={`relative z-10 flex flex-col justify-center w-full lg:w-1/2 px-6 sm:px-10 md:px-14 xl:px-20 py-16 md:py-20 transition-all duration-1000 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        {/* Badge eyebrow */}
        <div className="flex items-center gap-2 mb-8 md:mb-10 w-fit">
          <div
            className="flex items-center gap-2 px-4 md:px-5 py-2"
            style={{
              background: 'rgba(220,80,20,0.08)',
              border: '1px solid rgba(220,80,20,0.25)',
              borderRadius: '20px',
            }}
          >
            <span
              className="w-2 h-2 rounded-full flex-shrink-0"
              style={{
                background: '#DC5014',
                animation: 'pulse 2s cubic-bezier(0.4,0,0.6,1) infinite',
              }}
            />
            <span
              className="font-sans font-semibold uppercase whitespace-nowrap"
              style={{ color: '#143C3C', fontSize: '10px', letterSpacing: '0.15em' }}
            >
              YOUR COMMERCIAL ARM — ACROSS AMERICA
            </span>
          </div>
        </div>

        {/* Headline */}
        <h1
          className="font-playfair"
          style={{ lineHeight: 1.08, letterSpacing: '-0.02em', marginBottom: '24px' }}
        >
          <span
            className="block font-bold"
            style={{ fontSize: 'clamp(28px, 7vw, 58px)', color: '#143C3C', fontWeight: 700 }}
          >
            The Elite Commercial Arm
          </span>
          <span
            className="block font-bold"
            style={{ fontSize: 'clamp(28px, 7vw, 58px)', color: '#143C3C', fontWeight: 700 }}
          >
            Your Construction Business{' '}
            <span style={{ color: '#DC5014', fontStyle: 'italic' }}>Is Missing.</span>
          </span>
        </h1>

        {/* Sub-headline */}
        <p
          className="font-sans"
          style={{
            fontSize: 'clamp(16px, 2.5vw, 20px)',
            color: 'rgba(20,60,60,0.7)',
            maxWidth: '520px',
            lineHeight: 1.7,
            fontWeight: 300,
            marginBottom: '32px',
          }}
        >
          Stop working for your business and start leading an empire. We provide the branding, the sales team, and the{' '}
          <span style={{ color: '#DC5014', fontWeight: 700 }}>4,000 SQF showroom</span>{' '}
          to close $100K+ deals for you.
        </p>

        {/* Promise highlight */}
        <p
          className="font-sans"
          style={{
            fontSize: '16px',
            color: '#143C3C',
            fontWeight: 600,
            lineHeight: 1.6,
            marginBottom: '36px',
          }}
        >
          You Build. We Sell.
          <br />You Never Run Out of Work Again.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 mb-8">
          <button
            onClick={() => scrollTo('#contact')}
            className="font-sans font-bold whitespace-nowrap cursor-pointer transition-all duration-300 hover:brightness-110 active:scale-95 flex items-center justify-center gap-2"
            style={{
              background: '#DC5014',
              color: '#FFFFFF',
              padding: '0 32px',
              height: '52px',
              minHeight: '52px',
              borderRadius: '6px',
              fontSize: '13px',
              letterSpacing: '0.06em',
              border: 'none',
            }}
          >
            APPLY TO JOIN THE HUB
            <span style={{ fontSize: '15px' }}>→</span>
          </button>
          <button
            onClick={() => scrollTo('#showroom')}
            className="font-sans whitespace-nowrap cursor-pointer transition-all duration-300 active:scale-95 flex items-center justify-center gap-2"
            style={{
              background: 'transparent',
              border: '1px solid rgba(20,60,60,0.3)',
              color: '#143C3C',
              padding: '0 28px',
              height: '52px',
              minHeight: '52px',
              borderRadius: '6px',
              fontSize: '13px',
              letterSpacing: '0.06em',
              fontWeight: 400,
            }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.background = 'rgba(20,60,60,0.06)'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.background = 'transparent'; }}
          >
            <span style={{ fontSize: '14px' }}>▷</span>
            SEE HOW IT WORKS
          </button>
        </div>

        {/* Social proof */}
        <div className="flex items-center gap-3" style={{ marginTop: '20px' }}>
          <div className="flex items-center">
            {AVATARS.map((src, i) => (
              <div
                key={i}
                className="rounded-full overflow-hidden border-2 flex-shrink-0"
                style={{
                  width: '32px',
                  height: '32px',
                  borderColor: '#FFFFFF',
                  marginLeft: i === 0 ? '0' : '-10px',
                  zIndex: 4 - i,
                  position: 'relative',
                }}
              >
                <img src={src} alt="contractor" className="w-full h-full object-cover object-top" />
              </div>
            ))}
          </div>
          <div className="flex items-center gap-1">
            {[1, 2, 3, 4, 5].map((s) => (
              <i key={s} className="ri-star-fill" style={{ color: '#DC5014', fontSize: '11px' }} />
            ))}
          </div>
        </div>

        {/* Scarcity */}
        <div className="flex items-center gap-2" style={{ marginTop: '12px' }}>
          <span
            className="w-2 h-2 rounded-full flex-shrink-0"
            style={{ background: '#DC5014', animation: 'pulse 2s cubic-bezier(0.4,0,0.6,1) infinite' }}
          />
          <p className="font-sans italic" style={{ color: 'rgba(20,60,60,0.45)', fontSize: '11px' }}>
            Only 3 spots available this quarter — 2 already taken
          </p>
        </div>
      </div>

      {/* ── RIGHT COLUMN — Image + Floating Cards + Barky ── */}
      <div className="hidden lg:block relative w-1/2 flex-shrink-0">
        {/* Main image — full bleed, no border-radius */}
        <div className="absolute inset-0" style={{ overflow: 'hidden' }}>
          <img
            src="https://readdy.ai/api/search-image?query=Ultra-realistic%20cinematic%20photo%20bright%20warm%20Florida%20natural%20daylight%20golden%20hour%20light.%20Three%20elite%20commercial%20field%20professionals%20standing%20confidently%20in%20front%20of%20luxury%20Florida%20home%20entrance.%20Latino%20male%20center%20mid%2030s%20arms%20crossed%20strong%20posture%20natural%20confident%20smile%20wearing%20clean%20fitted%20dark%20teal%20polo%20shirt%20with%20embroidered%20logo%20on%20chest%20professional%20fitted%20cargo%20pants%20premium%20work%20boots.%20Latino%20male%20left%20late%2020s%20holding%20professional%20clipboard%20with%20project%20documents%20same%20dark%20teal%20branded%20uniform.%20Latina%20female%20right%20early%2030s%20holding%20tablet%20showing%20architectural%203D%20renders%20of%20luxury%20home%20warm%20professional%20smile%20same%20teal%20uniform.%20Lush%20Florida%20greenery%20in%20background%20warm%20afternoon%20golden%20sunlight%20shallow%20depth%20of%20field%20team%20in%20sharp%20focus.%20Elite%20confident%20professional%20commercial%20team%20no%20safety%20vests%20no%20helmets%20immaculate%20clean%20clothes.%20Warm%20terracotta%20tones%20teal%20accents%20bright%20Florida%20gold%20light%20cinematic%20sharp%208K%20photorealistic%20shot%20on%20RED%20camera%20anamorphic%20lens.&width=900&height=1100&seq=barkfy-hero-split-v3&orientation=portrait"
            alt="Barkfy elite commercial team"
            className="w-full h-full object-cover object-top"
          />
          {/* Subtle gradient overlay */}
          <div
            className="absolute inset-0"
            style={{ background: 'linear-gradient(to top, rgba(255,255,255,0.15) 0%, transparent 45%)' }}
          />
          {/* Left edge fade to blend with left column */}
          <div
            className="absolute inset-y-0 left-0"
            style={{ width: '80px', background: 'linear-gradient(to right, #FFFFFF, transparent)' }}
          />
        </div>

        {/* Floating Card 1 — top right */}
        <div
          className="absolute z-20 flex items-center gap-3"
          style={{
            top: '72px',
            right: '28px',
            background: '#FFFFFF',
            borderRadius: '10px',
            padding: '14px 18px',
            minWidth: '170px',
            boxShadow: '0 4px 20px rgba(20,60,60,0.12)',
          }}
        >
          <div
            className="w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0"
            style={{ background: 'rgba(20,60,60,0.08)' }}
          >
            <i className="ri-line-chart-line" style={{ color: '#143C3C', fontSize: '20px' }} />
          </div>
          <div>
            <p className="font-sans" style={{ color: '#999', fontSize: '11px', fontWeight: 500 }}>
              Revenue Growth
            </p>
            <p className="font-sans font-bold" style={{ color: '#143C3C', fontSize: '22px', lineHeight: 1.1 }}>
              +287%
            </p>
          </div>
        </div>

        {/* Floating Card 2 — bottom left (inside right column) */}
        <div
          className="absolute z-20 flex items-center gap-3"
          style={{
            bottom: '100px',
            left: '28px',
            background: '#FFFFFF',
            borderRadius: '10px',
            padding: '14px 18px',
            minWidth: '170px',
            boxShadow: '0 4px 20px rgba(20,60,60,0.12)',
          }}
        >
          <div
            className="w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0"
            style={{ background: 'rgba(220,80,20,0.08)' }}
          >
            <i className="ri-shake-hands-line" style={{ color: '#DC5014', fontSize: '20px' }} />
          </div>
          <div>
            <p className="font-sans" style={{ color: '#999', fontSize: '11px', fontWeight: 500 }}>
              Deals Closed
            </p>
            <p className="font-sans font-bold" style={{ color: '#DC5014', fontSize: '22px', lineHeight: 1.1 }}>
              400+
            </p>
          </div>
        </div>

        {/* BARKY — flutuando entre as duas colunas */}
        <div
          className="absolute z-30 flex flex-col items-center"
          style={{
            bottom: '40px',
            left: '-70px',
          }}
        >
          {/* Speech bubble */}
          <div
            style={{
              background: '#143C3C',
              borderRadius: '8px',
              padding: '10px 14px',
              color: '#FFFFFF',
              fontSize: '12px',
              fontWeight: 700,
              lineHeight: 1.45,
              position: 'relative',
              whiteSpace: 'nowrap',
              marginBottom: '8px',
            }}
          >
            I close deals so
            <br />you can keep building!
            <span
              style={{
                position: 'absolute',
                bottom: '-7px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: 0,
                height: 0,
                borderLeft: '7px solid transparent',
                borderRight: '7px solid transparent',
                borderTop: '7px solid #143C3C',
              }}
            />
          </div>
          {/* Barky PNG */}
          <img
            src={BARKY_URL}
            alt="Barky mascot"
            style={{ height: '200px', width: 'auto', objectFit: 'contain', display: 'block' }}
          />
        </div>
      </div>

      {/* Mobile: full-bleed background image */}
      <div className="absolute inset-0 lg:hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Ultra-realistic%20cinematic%20photo%20bright%20warm%20Florida%20natural%20daylight%20golden%20hour%20light.%20Three%20elite%20commercial%20field%20professionals%20standing%20confidently%20in%20front%20of%20luxury%20Florida%20home%20entrance.%20Latino%20male%20center%20mid%2030s%20arms%20crossed%20strong%20posture%20natural%20confident%20smile%20wearing%20clean%20fitted%20dark%20teal%20polo%20shirt%20with%20embroidered%20logo%20on%20chest%20professional%20fitted%20cargo%20pants%20premium%20work%20boots.%20Latino%20male%20left%20late%2020s%20holding%20professional%20clipboard%20with%20project%20documents%20same%20dark%20teal%20branded%20uniform.%20Latina%20female%20right%20early%2030s%20holding%20tablet%20showing%20architectural%203D%20renders%20of%20luxury%20home%20warm%20professional%20smile%20same%20teal%20uniform.%20Lush%20Florida%20greenery%20in%20background%20warm%20afternoon%20golden%20sunlight%20shallow%20depth%20of%20field%20team%20in%20sharp%20focus.%20Elite%20confident%20professional%20commercial%20team%20no%20safety%20vests%20no%20helmets%20immaculate%20clean%20clothes.%20Warm%20terracotta%20tones%20teal%20accents%20bright%20Florida%20gold%20light%20cinematic%20sharp%208K%20photorealistic%20shot%20on%20RED%20camera%20anamorphic%20lens.&width=900&height=1100&seq=barkfy-hero-split-v3&orientation=portrait"
          alt="Barkfy elite commercial team"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0" style={{ background: 'rgba(255,255,255,0.82)' }} />
      </div>
    </section>
  );
}
